import {useEffect} from "react";

import {RequestInfo} from "@repo/shared-core";

import {uxStack} from "./ux-stack-singleton.ts";

/**
 * So far, we're only reporting the perseus keypad.
 */
export type UXSlug = "math-input" | "doodlepad";

/**
 * Note that if there is no mobile app wrapping the current view, this hook is a no-op.
 */
export const useCloseableStack = (
    slug: UXSlug,
    isOpen: boolean,
    onClose: () => void | Promise<void>,
    extra?: any,
) => {
    useEffect(() => {
        // Not in the mobile app, or UX is closed
        if (!RequestInfo.isMobileApp || !isOpen) {
            return;
        }
        // Tell the app integration we're opened...
        uxStack().opened({slug, behavior: "close", extra});

        const unsubscribe = uxStack().listenForClose(slug, onClose);

        return () => {
            // Unsubscribe from the close UX signal...
            unsubscribe();

            // ...and tell the mobile app we're closed.
            uxStack().closed(slug);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- we do a simple stringify comparison for extra, rather than an instance comparison
    }, [slug, isOpen, onClose, JSON.stringify(extra)]);
};
